import React from "react";
import {IndicatorBox} from "./boxes/indicator.box";
import {IndicatorIconBox} from "./boxes/indicator-icon.box";
import {IndicatorBadgeBox} from "./boxes/indicator-badge.box";
import {IndicatorTextBox} from "./boxes/indicator-text.box";
import {IndicatorLayout} from "./consts/indicator-layout";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {CyClass} from "../../../common/cy-classes";
import {IndicatorIconWrapperBox} from "./boxes/indicator-icon-wrapper.box";
import {ISvgIconProps} from "../../basic-ui-components/icon/svg-icon/svg.icon";

export interface ProfileBoxMessagesIndicatorProps {
    /**
     * Normally, we should only receive numberOfAwaitingMessages, and when that's greater than 0, then the indicator is active
     * and the bubble shows the number.
     * But for challenges, we have only the information whether the user has active challenges or not.
     * So we accept both data, both are optional.
     * If both are missing, the button is inactive. If both are present, numberOfAwaitingMessages takes precedence and hasAwaitingMessages is ignored.
     * If hasAwaitingMessages is true and numberOfAwaitingMessages is undefined, the button is active but the badge is supressed
     */
    numberOfAwaitingMessages?: number;
    hasAwaitingMessages?: boolean;

    onClick: React.MouseEventHandler;
    displayLayout?: IndicatorLayout;
    iconComponent: React.ComponentType<ISvgIconProps>;
    className: string;
    text: string;
}

export class ProfileBoxMessagesIndicator extends OrbitComponent<ProfileBoxMessagesIndicatorProps> {

    private _captureElementRef = (element: HTMLDivElement) => {
        if(this.services.mediaQuery.lAndAbove) {
            this.services.freePlay.setFreePlayIndicatorDOMElementRef(element);
        }

    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if(this.services.mediaQuery.lAndAbove) {
            this.services.freePlay.setFreePlayIndicatorDOMElementRef(null);
        }

    }

    render() {
        const indicatorActive = this.indicatorIsActive();
        const IconComponent = this.props.iconComponent;

        return (
            <IndicatorBox displayLayout={this.props.displayLayout} className={this.props.className} onClick={this.onClick} ref={this._captureElementRef}>
                <IndicatorIconWrapperBox active={this.numberOfMessagesIsDefinedAndGreaterThanZero()}>
                    <IndicatorIconBox displayLayout={this.props.displayLayout} active={indicatorActive}>
                        {IconComponent ? <IconComponent/> : null}
                        {this.numberOfMessagesIsDefinedAndGreaterThanZero() ?
                            <IndicatorBadgeBox displayLayout={this.props.displayLayout} className={CyClass('cy-user-profile-messages-indicator')}>{this.props.numberOfAwaitingMessages}</IndicatorBadgeBox>
                            : null}
                    </IndicatorIconBox>
                </IndicatorIconWrapperBox>
                <IndicatorTextBox displayLayout={this.props.displayLayout} active={indicatorActive}>
                    {this.props.text}
                </IndicatorTextBox>
            </IndicatorBox>
        );
    }

    private onClick = (e: React.MouseEvent) => {
        if (!this.indicatorIsActive()) {
            return;
        }
        this.props.onClick(e);
    }

    private numberOfMessagesIsDefinedAndGreaterThanZero() {
        return this.props.numberOfAwaitingMessages !== undefined && this.props.numberOfAwaitingMessages > 0;
    }

    private indicatorIsActive() {
        return this.numberOfMessagesIsDefinedAndGreaterThanZero() || !!this.props.hasAwaitingMessages;
    }

}
